import React, { useState } from 'react';
import './TermsAndConditions.css';
import { useNavigate } from 'react-router-dom';
import '../CarImageComponent.css';
import website from '../../../Terms And Conditions/Website Terms of Use.pdf';
import privacy from '../../../Terms And Conditions/PRIVACY POLICY.pdf';
import Business from '../../../Terms And Conditions/Business Terms and Conditions.pdf';
import Refund from'../../../Terms And Conditions/Refund Policy.pdf'

import { FaShieldAlt, FaGavel,FaBusinessTime, FaUndoAlt,FaEnvelope } from 'react-icons/fa'; // Import icons from react-icons
import TCBackground from '../Termsandconditions bg';

const TermsAndConditionspage = () => {
  const navigate=useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const privacypolicy = () => {
    window.open(privacy,'_blank');
  };
  const websiteterms = () => {
    window.open(website,'_blank');
  };
  const RefundButton = () => {
    window.open(Refund,'_blank');
  };
  const contactbutton = () => {
    navigate("/ContactUs");
  };
  const Businessbutton = () => {
    window.open(Business,'_blank');
  };
  

  return (
    <>
    <div className="car-image-container">
          <div className="contentcarimage" style={{background:'transparent'}}>
            <h1 style={{fontSize:'2rem', color:'white'}}><strong>Terms and Conditions</strong> </h1>
            <h1 className="heading" style={{color:'yellow'}}>For You</h1>
            
          </div>
          {/* <img
            src={ford2}
            alt="Car"
            className="car-image"
          /> */}
        </div>
        <TCBackground/> 
        <div className="policy-buttons">
      <button className="policy-button" onClick={privacypolicy}>
        <FaShieldAlt className="policyicon" /> Privacy Policy
      </button>
      <button className="policy-button" onClick={RefundButton}>
        <FaUndoAlt className="policyicon" /> Refund Policy
      </button>
      <button className="policy-button" onClick={Businessbutton}>
        <FaBusinessTime className="policyicon" /> Business Terms and Conditions
      </button>
      <button className="policy-button" onClick={websiteterms}>
        <FaGavel className="policyicon" /> Website terms of Use
      </button>
    </div>
    <div className="contact-section">
  <h3>Have Questions?</h3>
  <p>If you have any questions about our policies, feel free to reach out to us:</p>
  
<button className="policy-button" onClick={contactbutton}>
        <FaEnvelope className="policyicon" /> Contact Us
      </button>
      
</div>
    </>
  );
};

export default TermsAndConditionspage;
